import { Module } from 'vuex';
import { TimeZoneState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: TimeZoneState = {
    timeZone: undefined,
    index: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const timeZone: Module<TimeZoneState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
